import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  documentTitle: {
    color: theme.palette.success.main,
  },
}));

export default useStyles;
